import { createContext, useContext } from "react";
import Collapse from "../../components/UI/Collapse";

// "Ver métricas" fica no cabeçalho do admin (como em Vendas); a seção só
// decide onde os cartões abrem — logo abaixo do filtro.
export const MetricsContext = createContext(false);

export function AdminMetrics({ children }) {
    const open = useContext(MetricsContext);
    return (
        <Collapse open={open} closedClassName="-mt-6" innerClassName="pb-2">
            {children}
        </Collapse>
    );
}
